import React from "react";

export const People = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="currentColor" opacity="0.72">
      <path d="M15.437 10.375a4.063 4.063 0 10-4.064-4.062 4.046 4.046 0 004.064 4.062zM10.835 13.843c-.227.071-.2.388.024.469a5.25 5.25 0 012.906 2.575l.002.004 1.186 2.371v.002a2.75 2.75 0 01.152 2.11c-.06.176.063.375.25.375h7.024a1.626 1.626 0 001.447-2.356l-1.544-3.088a4.877 4.877 0 00-4.357-2.681h-5.721a4.877 4.877 0 00-1.369.22z"></path>
    </g>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10 9.875C10 11.601 8.6 13 6.874 13a3.114 3.114 0 01-3.126-3.125 3.126 3.126 0 016.252 0zM.185 21.154c.226.369.628.594 1.062.596H12.5a1.25 1.25 0 001.113-1.813l-1.188-2.375a3.751 3.751 0 00-3.35-2.062H4.672a3.751 3.751 0 00-3.289 2.062l-1.25 2.375a1.25 1.25 0 00.05 1.217z"
      clipRule="evenodd"
    ></path>
  </svg>
);
